//------------------------------------------------------------------
// External
//------------------------------------------------------------------

import { nodeArray, relativeTarget, offset } from '@meteora-digital/helpers';
import SimpleSelector from 'simple-selector';
import Tween from '@meteora-digital/tween';
import { tns } from "tiny-slider/src/tiny-slider";

//------------------------------------------------------------------
// Internal
//------------------------------------------------------------------

import Filters from '../classes/filters';
import Video from '../classes/video';
var Scroll = new Tween();

// Filtering
nodeArray(document.querySelectorAll('.js-filter')).forEach(function (section) {
  return new Filters(section);
});

// Anchor links
nodeArray(document.querySelectorAll('[data-scroll-to]')).forEach(function (anchor) {
  var target = document.querySelector(anchor.getAttribute('data-scroll-to')) || false;
  if (target) {
    anchor.addEventListener('click', function (e) {
      console.log(target);
      e.preventDefault();
      Scroll.tween({
        from: window.pageYOffset,
        to: offset(target).y - 200
      }, function (value) {
        return window.scrollTo(0, value);
      });
    });
  }
});

// Videos
var handleVideos = function handleVideos() {
  nodeArray(document.querySelectorAll('[data-video]')).forEach(function (el) {
    var video = new Video(el.getAttribute('data-video'));
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var modal = document.createElement('div');
      var modalInner = document.createElement('div');
      modal.classList.add('video-modal');
      modalInner.classList.add('video-modal__inner');
      modal.appendChild(modalInner);
      modalInner.innerHTML = video.render();
      document.body.appendChild(modal);
      setTimeout(function () {
        return modal.classList.add('js-active');
      }, 5);
      modalControls(modal);
    });
  });
};
var modalControls = function modalControls(modal) {
  modal.addEventListener('click', function (e) {
    if (relativeTarget(e.target, modal)) {
      modal.classList.remove('js-active');
      setTimeout(function () {
        return modal.remove();
      }, 300);
    }
  });
};
handleVideos();
window.addEventListener('filtered', function () {
  return handleVideos();
});
nodeArray(document.querySelectorAll('.js-slider--link-slider')).forEach(function (slider) {
  var controller = tns({
    container: slider,
    nav: true,
    gutter: 0,
    mouseDrag: true,
    responsive: {
      640: {
        items: 2
      },
      960: {
        items: 3
      }
    }
  });
  var info = controller.getInfo();
  var update = function update(data) {
    return info.navContainer.firstElementChild.setAttribute('data-info', data.displayIndex + '/' + data.slideCount);
  };
  controller.events.on('indexChanged', function (info, eventName) {
    return update(info);
  });
  setTimeout(function () {
    update({
      displayIndex: 1,
      slideCount: info.slideCount
    });
  }, 1000);
});

// Selectors
nodeArray(document.querySelectorAll('.js-select')).forEach(function (select) {
  return new SimpleSelector(select, {
    search: select.children.length >= 10
  });
});